import React from 'react'

const DisclaimerBanner = () => {
    return (
        <section className="disclaimer-banner">
            <h2>Disclaimer</h2>
            <p>Zonvex Slots is a social casino game created purely for fun and entertainment. No real money is
                involved, and no prizes can be won. The game offers exciting spins designed for players aged <strong>18 and
                    above</strong>. We encourage responsible play and remind users that this is a risk-free, lighthearted
                gaming experience. Enjoy the crypto vibes and have fun!</p>
        </section>
    )
}

export default DisclaimerBanner